<template>
  <div class="email-dialog-container" v-if="visible">
    <div class="email-dialog-mask" @click="handleCancel"></div>

    <div class="email-dialog">
      <div class="email-dialog-header">
        <h3>请输入您的接收邮箱</h3>
      </div>

      <div class="email-dialog-body">
        <van-field
            v-model="email"
            type="email"
            placeholder="example@domain.com"
            :error-message="errorMessage"
            @input="validateEmail"
        />
      </div>

      <div class="email-dialog-footer">
        <van-button plain type="default" size="small" @click="handleCancel">取消</van-button>
        <van-button type="primary" size="small" @click="handleConfirm" :disabled="!isValid">确认</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {Field, Button, Toast} from 'vant';

export default {
  name: 'EmailInputDialog',
  components: {
    [Field.name]: Field,
    [Button.name]: Button
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      email: '',
      isValid: false,
      errorMessage: ''
    };
  },
  methods: {
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.email) {
        this.errorMessage = '请输入邮箱地址';
        this.isValid = false;
      } else if (!emailRegex.test(this.email)) {
        this.errorMessage = '请输入有效的邮箱地址';
        this.isValid = false;
      } else {
        this.errorMessage = '';
        this.isValid = true;
      }
    },
    handleConfirm() {
      if (this.isValid) {
        this.$http.post('/user/setEmail',{email:this.email}).then(()=>{
          Toast.success('提交成功');
          this.$emit('confirm', this.email);
          this.reset();
        })
      }
    },
    handleCancel() {
      this.$emit('cancel');
      this.reset();
    },
    reset() {
      this.$store.dispatch('USERINFO').then(()=>{
        this.email = '';
        this.isValid = false;
        this.errorMessage = '';
      })
    }
  }
};
</script>

<style scoped>
.email-dialog-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}

.email-dialog-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.email-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  max-width: 200px; /* 原400px */
  background-color: #fff;
  border-radius: 4px; /* 原8px */
  overflow: hidden;
  padding: 10px 20px; /* 原20px 40px */
}

.email-dialog-header {
  padding: 8px; /* 原16px */
  text-align: center;
  border-bottom: 1px solid #ebedf0;
  height: 45px; /* 原90px */
  display: flex;
  justify-content: center;
  align-items: center;
}

.email-dialog-header h3 {
  margin: 0;
  font-size: 12px; /* 原24px */
  font-weight: 500;
}

.email-dialog-body {
  border: 1px solid #52A7F7;
}

.email-dialog-footer {
  display: flex;
  padding: 5px 8px; /* 原10px 16px */
  border-top: 1px solid #ebedf0;
}

.email-dialog-footer .van-button {
  flex: 1;
  margin: 0 3px; /* 原5px */
}
</style>
